import React from 'react'
import PropTypes from 'prop-types'
import { useFilterValue, useWillConstrain } from '@morningtrain/react-filters'
import { observer } from 'mobx-react'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'

import da from 'date-fns/locale/da'
registerLocale('da', da)

function WeekFilter (props) {
  const [value, setValue] = useFilterValue(props.name, props.defaultValue)

  useWillConstrain(props.name, value)

  let startOfCurrentWeek = moment()
  let endOfCurrentWeek = moment()

  if (value && value.year && value.week) {
    const newStart = moment().startOf('isoWeek').isoWeekYear(value.year).isoWeek(value.week)
    startOfCurrentWeek = newStart
    endOfCurrentWeek = newStart.clone().endOf('isoWeek')
  }

  const handleDateChange = (date) => {
    const momentDate = moment.utc()

    momentDate.year(date.getFullYear())
    momentDate.month(date.getMonth())
    momentDate.date(date.getDate())
    momentDate.hour(0)
    momentDate.minute(0)
    momentDate.seconds(0)
    momentDate.millisecond(0)

    setValue({
      year: momentDate.isoWeekYear(),
      week: momentDate.isoWeek()
    })
  }

  const handlePrevious = () => {
    const newStart = moment().startOf('isoWeek').isoWeekYear(value.year).isoWeek(value.week)
    const date = newStart.clone().subtract(1, 'week')

    setValue({
      year: date.isoWeekYear(),
      week: date.isoWeek()
    })
  }

  const handleNext = () => {
    const newStart = moment().startOf('isoWeek').isoWeekYear(value.year).isoWeek(value.week)
    const date = newStart.clone().add(1, 'week')

    setValue({
      year: date.isoWeekYear(),
      week: date.isoWeek()
    })
  }

  const DatePickerSelector = ({ _val, onClick }) => {
    if (!value) {
      return null
    }

    return (
      <button onClick={onClick}>
        <div>
          {value.week} - {startOfCurrentWeek.format('DD-MM-YYYY')} - {endOfCurrentWeek.format('DD-MM-YYYY')}
        </div>
      </button>
    )
  }

  return (
    <div className='datepicker-container flex'>
      <SquareButton onClick={() => handlePrevious()} color='btn-white' className='rounded-lg mr-0.5' big>
        <Icons.ArrowLeft className='w-4' />
      </SquareButton>
      <DatePicker
        selected={startOfCurrentWeek.toDate()}
        onChange={(date) => handleDateChange(date)}
        showWeekNumbers
        formatWeekDay={nameOfDay => nameOfDay.substr(0, 3)}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode='select'
        locale='da'
        customInput={<DatePickerSelector />}
      />
      <SquareButton onClick={() => handleNext()} color='btn-white' className='rounded-lg ml-0.5' big>
        <Icons.ArrowRight className='w-4' />
      </SquareButton>
    </div>
  )
}

WeekFilter.defualtProps = {
  defaultValue: { year: null, week: null }
}

WeekFilter.propTypes = {
  name: PropTypes.string.isRequired
}

export default observer(WeekFilter)
